import { OAuthAPI } from "../../OAuthAPI/src/OAuthAPI";
import TAUI from "./ui/ta_UI";

let oAuthAPIInstance = undefined;

try {
  oAuthAPIInstance = new OAuthAPI(OAuthConfigs);
} catch (error) {
  if (error.isManagedException && isOauthConfigProvided(OAuthConfigs)) {
    TAUI.growl(
      error.message,
      { feature: "OpenID Authentication" },
      { type: "danger", delay: 0 }
    );
  }
  console.error(`Ran into errors while creating OAuthAPI instance. ${error}`);
}

export function isOauthConfigProvided(OAuthConfigs) {
  return OAuthConfigs.some((oAuthObj) => !_.isEmpty(oAuthObj.clientId));
}

export default oAuthAPIInstance;
